export default __webpack_public_path__ + "static/media/Business process outsourcing.ae7a519d.png";